import { useQuery } from '@fv/client-core'
import type { AccountVendor, AccountVendorUser } from '@fv/models'
import type {
  AdminVendorOverview,
  SearchVendorRequest,
  VendorSearchResult,
} from '@fv/models/admin'
import type { DTO } from '@fv/models/core'

import { adminFetch } from '@/utils'

export const vendorQueryKeys = {
  all: ['vendors'],
  account: (id: string) => [...vendorQueryKeys.all, 'account', id],
  overview: (id: string) => [...vendorQueryKeys.all, id, 'overview'],
  users: (id: string) => [...vendorQueryKeys.all, id, 'users'],
  search: (search: string) => [...vendorQueryKeys.all, 'search', search],
}

export const useVendorOverview = (vendorId: string) => {
  return useQuery(
    vendorQueryKeys.overview(vendorId),
    () => adminFetch<AdminVendorOverview>(`/vendors/${vendorId}`),
    {
      staleTime: Infinity,
      enabled: !!vendorId,
    },
  )
}

export const useVendorUsers = (id: string) =>
  useQuery(vendorQueryKeys.users(id), () =>
    adminFetch<AccountVendorUser[]>(`/vendors/${id}/users`),
  )

export const useListAccountVendors = (accountId: string) => {
  return useQuery(vendorQueryKeys.account(accountId), () =>
    adminFetch<Array<DTO<AccountVendor>>>(`/accounts/${accountId}/vendors`),
  )
}

export const useVendorSearch = (search: SearchVendorRequest) => {
  return useQuery(
    vendorQueryKeys.search(search.search),
    () => adminFetch<VendorSearchResult[]>(`/vendors`, { query: search }),
    { enabled: !!search.search, staleTime: 1000 * 60 * 5 },
  )
}
